import Idioma from '../Idioma'
export default new Idioma({
  idioma:'en',
  pasos: {
    uno: 'Make your booking',
    dos: 'Choose your services',
    tres: 'Personal details',
    cuatro: 'Booking summary and payment'
  },
  resumen:{
    para: 'for',
    personas: 'persons(s)',
    entrada: 'Arrival:',
    salida: 'Departure:'
  },
  datosReserva:{
    selecciona: 'Select type of accommodation',
    sistema: 'Booking system',
    antes: 'Information before booking',
    textoAntes:[
      'Please read the instructions at each step carefully to ensure the best possible booking experience.',
      'After completing the online booking process you\'ll receive an email with your booking code and information. Please save this information in case you need to modify your booking.',
      'Please contact the accommodation provider if you need to cancel a booking.',
      'Use the \'Comments\' box during booking for any requests or requirements. The more information we have, the better we can fulfil your request.',
      'Remember, you only have a limited time to complete your booking (subject to bed availability); the system blocks the beds that you request until you make the corresponding advanced payment. If you exceed this time limit, your booking will be cancelled and you\'ll be required to start the process again.'
    ],
    fechas:'Information about dates',
    textoFechas:[
      'Same-day bookings and bookings made 24 hours or less in advance are not available online. Please contact the accommodation provider directly.',
      'The maximum number of nights that can be booked online is 4 nights.'
    ],
    numeroPlazas: 'Number of beds',
    plazasSelect:'Select the # of people',
    plazas:'Information about beds',
    textoPlazas:[
      'This online booking system has a limited number of beds at each accommodation. Please call the accommodation provider if you can\'t book online.',
      'The beds in most of the accommodations on this booking engine are in a shared room. Please contact the accommodation provider directly if you\'d like to request a different type of arrangement.\n'
    ],
    multiple:{
      cabecera:'Multiple booking system:',
      texto:'Check availability at the first mountain hut and use this tool to plan your entire route.'
    },
    otro:'Would you like to include another hut in your booking?',
    seleccionaOtro:'Select another accommodation',
    otroBtn: 'Add to booking',
    errorReserva:'Check the dates selected or the number of people',
    continuar:'Continue',
    errors:{
      cerrado:'You cannot select a day the accommodation is closed',
      completo: 'A full day cannot be selected as the arrival date',
      online: 'Please contact the accommodation provider directly to book this day',
      salida: 'You cannot select a day the accommodation is closed as the departure date',
      rango: 'Does not meet the requirements to complete the booking\n',
      invalidDate: 'You cannot select today or tomorrow as check-in date',
      personas: {
        principio: 'beds are ',
        final: 'unavailable on'
      }
    }
  },
  datosServicios:{
    selecciona:'Select services',
    fecha: 'Date',
    desayuno: 'Breakfast',
    comida: 'Lunch',
    picnic: 'Picnic',
    cena: 'Dinner',
    pernocta: 'Overnight',
    observaciones: 'Please use this section to add any comments related to the service you\'d like to book.\n',
    btnReserva: 'Continue with booking',
    btnCancelar: 'Cancel booking',
    infoCabecera:'Information about services',
    cerrarCancelar: 'Continue with booking',
    confirmarCancelar: 'Cancel booking',
    textoCancelar: 'Do you want cancel this booking?',
    info:'If you plan to arrive after 7 p.m., please contact the accommodation provider to confirm whether you can reserve dinner service on your arrival day.',
    otrosServicios:{
      otros:'Additional services'
    }
  },
  datosResumen:{
    resumen: 'Booking summary',
    entrada: 'Arrival date:',
    salida: 'Departure date:',
    distintos: 'Services other than overnight stays',
    dia: 'Day',
    totalAdelanto: 'Advance payment amount by hut',
    textoAdelanto:[
      'This amount is an advance payment only. To check the full booking price, please visit the price section on the accommodation\'s website. Please remember that member discounts apply to FEDME (Spanish Federation for Mountain and Climbing Sports) members and members of the European Reciprocal Agreement for the use of other mountain club\'s huts.'
    ],
    total: 'Total advance payment for booking:',
    pago: 'Personal details and payment',
    tiempoRestante: 'Remaining time to complete the booking:',
    tiempoFin:'Your booking session has expired.',
    plazas:'Number of beds',
    noches:'Number of nights',
    AceptarBtn:'Accept and pay',
    CancelarBtn:'Cancel booking',
    cerrarCancelar: 'Continue with booking',
    confirmarCancelar: 'Cancel booking',
    textoCancelar: 'Do you want cancel this booking?'
  },
  datosPersonales:{
    intro: 'If you are already registered user in albeguesyrefugios.com',
    mensaje: ['You will have rapid and effortless access', 'to your information'],
    opcion: 'You can also',
    continuar: 'continue without registering',
    nombre:'Name',
    apellidos:'Last Name(s)',
    dni:'Passport',
    fnac:'Date of birth',
    direccion:'Address',
    cp:'Postcode',
    poblacion:'Town',
    provincia:'Province',
    pais:'Country',
    tfno:'Phone Number',
    club:'Club name',
    correoe:'Email',
    confirmar:'Confirm email',
    registro:'Would you like to register on our booking platform using these personal details?',
    observaciones: 'Please use this section to add any comments related to the booking.',
    crearUsuario: 'Do you want to create a user with this data?',
    tarjetainfo: 'I have read the information about the FAM (Aragonese Mountaineering Federation) membership cards.',
    infoTarjetaCabecera:'Information about membership cards',
    infoTarjeta:'In the refuges and shelters managed by the FAM, only the presentation of the federative card of the community that is within the agreement of mutual correspondence of refuges, either regional or national license, will be accepted as proof of being Federated (and therefore have a discount on prices).',
    informacion:'I would like to receive information and news about mountain huts and hostels.',
    conformidad: {
      acepto:'I accept ',
      y:'and'
    },
    condiciones:'the booking Terms and Conditions',
    proteccion:{
      acepto: 'I accept ',
      datos:'Data Protection Law'
    },
    AceptarBtn:'Accept and pay',
    CancelarBtn:'Cancel booking',
    cerrarCancelar: 'Continue with booking',
    confirmarCancelar: 'Cancel booking',
    textoCancelar: 'Do you want cancel this booking?',
    legal:{
      condiciones:{
        titulo:'ON-LINE BOOKING CONDITIONS',
        generales: {
          titulo: 'Terms and conditions',
          texto:[
            'The making of a reservation implies the acceptance of the operating rules and schedules of the establishment on which it is made.',
            'The establishments that appear on this page are mostly hostels and mountain refuges. In this type of establishment, and except for specific exceptions, the accommodation is in a shared multiple room, being in many cases necessary the use of a sleeping bag or similar.',
            'In many of the establishments the menus served are closed, and there is no possibility of choosing between various dishes or an à la carte menu.',
            'It is necessary to have consulted the section "How to get there" before making a reservation, as some of the refuges are at high altitude and can only be reached on foot.',
            'To cancel a reservation you must contact the establishment.'
          ]
        },
        anticipo: {
          titulo: 'Advance Booking',
          inicio: [
            'In order to make an online reservation it is necessary to pay a deposit. The amount of the deposit depends on the services booked.',
            'The refund conditions are as follows:'
          ],
          lista:[
            'If reservations are cancelled within 6 days of the reservation date, 100% of the advance payment charged will be refunded minus the return and booking engine costs if these are originated.',
            'If cancellations are made within the last 5 days of the reservation date, 100% of the total deposit will be charged.',
            'The refund costs are 1€ plus 0.25€ per person and overnight stay up to a maximum of 5€.'
          ],
          fin:[
            'In case of "force majeure" 100% of the deposit will be refunded. This concept of "force majeure" would have to be considered by the property manager, deciding whether or not a case of reservation cancellation is "force majeure", and if the reserving party disagrees with the guard\'s decision, he/she may then refer the matter to the property manager.',
            'In the establishments of the F.A.M. there is a time limit of arrival to have the reserved place. If these schedules are not met, the place will be free for users who demand it. Consult the conditions of the regulations for each shelter.'
          ]
        }
      }
    },
    avisoLegal:{
      tituloGeneral:'Aviso legal',
      info:{
        titulo: 'Información legal',
        texto:[
          'En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSICE) presentamos la siguiente información:',
          '',
          'Razón Social: Federación Aragonesa de Montañismo',
          'Dirección: C/. Albareda 7, 4º 4ª, 50004. Zaragoza',
          'C.I.F.: V50120211',
          'Teléfono: 976227971',
          'E-mail: fam@fam.es',
          'Datos de la inscripción en el Registro de Federaciones: 05/3',
          '',
          'Razón Social: PRAMES S.A.',
          'Dirección: Camino de los Molinos, 32. 50015. Zaragoza.',
          'C.I.F: A50223031',
          'Teléfono: 976106170',
          'E-mail: lopd@prames.com',
          'Datos de la Inscripción en el Registro Mercantil: 10.086 Folio: 185 Tomo: 841',

        ]
      },
      proteccion:{
        titulo: 'Data protection',
        texto:[
          '1. By completing the registration or contact form, sending an e-mail or calling by phone, your personal data will become the responsibility of the company whose data are listed in section 1. Legal Information.',
          '2. These data are used to respond to your request or query as soon as possible because you provide them to us informed and freely for that purpose.',
          'We will also communicate commercially by electronic means with our customers based on our legitimate interest in offering them products and services similar to those they initially contracted from us.',
          'For other treatments or purposes related to the provision of our services or the development of our activity, you can obtain more information in the Privacy Policy of PRAMES, S.A. or request them in our contact address.',
          '3. Personal data collected on our website are processed in compliance with the requirements of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data.',
          '4. Once the data are no longer necessary for the purposes for which they were collected, they will be kept at the disposal of the competent public administrations for the legal retention periods, i.e. as long as a law may require us to submit them. Once these periods have expired, they will be kept blocked until their subsequent destruction or deletion is possible.',
          '5. You can exercise your rights of access, rectification, suppression, opposition, limitation and portability of your personal data by submitting a copy of an identification document to: fam@fam.es.',
          '6. You can revoke the consent given for the sending of electronic communications at the time of booking, at the above address.',
          '7. You can find more information about your rights or file a complaint with the competent supervisory authority at the Spanish Data Protection Agency http://www.agpd.es - C/ Jorge Juan, 6. 28001 - Madrid (901 100 099 - 912 663 517).'
        ]
      },
      limitacion:{
        titulo: 'Limitation of Liability',
        texto: [
          '1. The Aragonese Mountaineering Federation provides the corporate website as a means of publicizing its activities and services, and to allow contact with members. The information on the website is presented as merely indicative or informative and shall at no time be considered binding.',
          '2. The entity is not responsible for any possible computer damage that the user may suffer while visiting our website on the understanding that those can not be attributable to the entity.',
          '3. The entity is not responsible for the content of sites managed by third parties that are linked from the website, and such links do not imply the existence of any kind of relationship between the Federación Aragonesa de Montañismo and those third parties.'
        ]
      },
      propiedad:{
        titulo: 'Intellectual Property Rights',
        texto: [
          '1. All contents of this website, understood as such texts, drawings, graphics, photographs, images, videos, music, code, the design itself and any other creation are property of Federación Aragonesa de Montañismo and PRAMES SA or their respective owners through the corresponding license, authorization or transfer of rights and are protected under the legislation on Intellectual and Industrial Property.',
          '2. In no case shall it be understood that the making available to the public of the web page constitutes a waiver, transfer or license of the rights that Federación Aragonesa de Montañismo and PRAMES, S.A. have over the contents of the same.',
          '3. Any use of the contents of our website, including modification, copying, reproduction, transmission, etc. is prohibited without the prior written authorization of the entity.'
        ]
      }
    },
    seguro: {
      titulo: 'Attention',
      texto: [
        'alberguesyrefugios.com uses secure payment',
        'Check that your card has the secure payment activated before confirming your booking.'
      ]
    },
    btnPagar:'Confirm personal data',
    errores:{
      obligatorio: 'This field is required',
      nombre:'This field is required. Must be 3 characters or more.',
      apellidos:'This field is required. Must be 3 characters or more.',
      dni:'This field is required. Must be 3 characters or more.',
      fnac:'This field is required and you must be of legal age',
      direccion:'This field is required. Must be 3 characters or more.',
      cp:'This field is required. Must be 5 characters or more.',
      poblacion:'This field is required. Must be 3 characters or more.',
      provincia:'This field is required. Must be 3 characters or more.',
      pais:'This field is required. Must be 3 characters or more.',
      correo:'This field is required. Must be in email format.',
      confirmarCorreo:'Emails must match.',
      tfno:'This field is required. Must be 3 characters or more.'
    },
    login:{
      btnRegistrado:'Log in',
      btnNuevo: 'I want to reserve',
      saludo:'Hello ',
      info:'This information will be used to complete the booking. They are not modified in your file.',
      btnSalir:'Exit and cancel booking',
      cerrarCancelar: 'Continue with booking',
      confirmarCancelar: 'Cancel booking',
      textoCancelar: 'Do you want cancel this booking?',
      modal:{
        titulo:'Log in',
        olvido: 'Did you forget the password?',
        usuario:'Email',
        password:'Password',
        error: 'We have not been able to meet this data',
        btnCancelar:'Cancel',
        btnAceptar:'Accept'
      }
    },
    tituloExiste: 'Registered user',
    existe: 'There is already a user registered with this email',
    covid: {
      pre:'I accept the',
      anchor: 'new conditions',
      post: 'by COVID19'
    },
  },
  datosCalendario: {
    selected: 'You have selected:',
    night: 'Night',
    nights: 'Nights',
    button: 'Button',
    clearButton: 'Clear',
    submitButton: 'Submit',
    'checkin-disabled': 'Check-in disabled',
    'checkout-disabled': 'Check-out disabled',
    'day-names-short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'day-names': ['Saturday', 'Monday', 'Tuesday', 'Webnesday', 'Thursday', 'Friday', 'Saturday'],
    'month-names-short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dic'],
    'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'Dicember'],
    'error-more': 'L\'intervallo di date non deve avere più di 1 notte',
    'error-more-plural': 'Date range cannot be less than %d nights',
    'error-less': 'Date range cannot be less than 1 night',
    'error-less-plural': 'Date cannot range be less than %d nights',
    'info-more': 'Select a date range.',
    'info-more-plural': 'Select a date range greater than 1 night',
    'info-range': 'Select a date range between %d and %d nights',
    'info-range-equal': 'Select %d nights date range',
    'info-default': 'Select a date range.',
    'aria-application': 'Calendar',
    'aria-selected-checkin': 'Data selezionata come check-in, %s',
    'aria-selected-checkout': 'Data selezionata come check-out, %s',
    'aria-selected': 'Data selezionata, %s',
    'aria-disabled': 'Non disponibile, %s',
    'aria-choose-checkin': 'Scegli %s come data del check-in',
    'aria-choose-checkout': 'Scegli %s come data del check-out',
    'aria-prev-month': 'Muovi indietro per visualizzare il mese precedente',
    'aria-next-month': 'Muovi in avanti per visualizzare il mese successivo',
    'aria-close-button': 'Chiudi il datepicker',
    'aria-clear-button': 'Cancella le date selezionate',
    'aria-submit-button': 'Invia il form',
    "status-opened": "Opened",
    "status-closed": "Closed",
    "status-full": "Full",
    "status-online": "No online spaces, call by phone"
  },
});


// WEBPACK FOOTER //
// ./src/_locale/translations/en.js